import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const Privacy = () => (
  <div className="min-h-screen max-w-3xl mx-auto px-6 py-10 text-white/85">
    <Link to="/" className="inline-flex items-center gap-2 text-white/60 hover:text-white mb-6"><ArrowLeft size={16} /> Back</Link>
    <h1 className="font-display text-5xl text-white">Privacy Policy</h1>
    <p className="text-white/50 text-sm mt-2">Last updated: {new Date().toLocaleDateString()}</p>

    <div className="mt-8 space-y-6 leading-relaxed">
      <section>
        <h2 className="text-xl font-semibold text-white">What we collect</h2>
        <p>Your Google profile (name, email, avatar), the shows you save / watch, and your subscription status. We don’t store passwords — Google handles that.</p>
      </section>
      <section>
        <h2 className="text-xl font-semibold text-white">How we use it</h2>
        <p>To personalize your homepage (Continue Watching, My List), process payments through Square, and improve the service. We do <span className="text-white font-semibold">not</span> sell your data.</p>
      </section>
      <section>
        <h2 className="text-xl font-semibold text-white">Third parties</h2>
        <ul className="list-disc list-inside space-y-1">
          <li><span className="text-white">Google</span> — authentication only</li>
          <li><span className="text-white">Square</span> — payment processing (we never see your card number)</li>
          <li><span className="text-white">TMDB</span> — movie/TV metadata</li>
          <li><span className="text-white">YouTube</span> — trailer playback (standard YouTube cookies apply)</li>
        </ul>
      </section>
      <section>
        <h2 className="text-xl font-semibold text-white">Your rights</h2>
        <p>Email <a className="text-[#E50914] hover:underline" href="mailto:ponomobiz@gmail.com">ponomobiz@gmail.com</a> and we’ll delete your account and all associated data within 14 days.</p>
      </section>
      <section>
        <h2 className="text-xl font-semibold text-white">Cookies</h2>
        <p>We use an httpOnly session cookie to keep you signed in. That’s it.</p>
      </section>
      <section>
        <h2 className="text-xl font-semibold text-white">Children</h2>
        <p>BLUNT TV is not directed at children under 13. Kids profiles hide mature content automatically but parents should supervise account usage.</p>
      </section>
    </div>
  </div>
);

export default Privacy;
